var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#E8F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6261 18.6294H21.8218V28.5996H33.6261V18.6294Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6198 18.2119C21.171 18.2119 20.8093 18.5707 20.8093 19.0172L20.8127 28.2631C20.7905 28.6985 21.0367 29.0684 21.5309 29.0684H33.1928C33.6297 29.0684 33.9999 28.8221 33.9939 28.4259L33.9999 19.0172C33.9999 18.5707 33.6382 18.2119 33.1894 18.2119H21.6198ZM21.4574 18.8792H33.345L33.3484 28.3935H21.4608L21.4574 18.8792Z",
    fill: "#0071C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3821 19.291L27.6832 23.8441V24.4593C27.7266 24.4688 27.7716 24.4681 27.8146 24.4573C27.8576 24.4465 27.8975 24.4259 27.9312 24.3971L33.3821 20.0443V19.291Z",
    fill: "#0071C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0658 19.291L27.7646 23.8441V24.4593C27.7213 24.4688 27.6763 24.4681 27.6333 24.4573C27.5902 24.4465 27.5503 24.4259 27.5167 24.3971L22.0658 20.0443V19.291Z",
    fill: "#0071C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.42 32.9446V14.0557L14 15.944V31.0553L25.42 32.9446Z",
    fill: "url(#paint0_linear_875_3189)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4178 20.1323C18.4164 20.1323 16.7881 20.9692 16.7881 23.6023C16.7881 26.1797 18.3979 27.0021 19.3918 26.9813C21.2326 26.9428 21.946 25.0851 21.946 23.5242C21.946 21.8343 21.2441 20.1323 19.4178 20.1323ZM19.3137 21.4493C20.1154 21.4493 20.6029 22.2607 20.6029 23.4996C20.6029 24.5954 20.1943 25.6365 19.326 25.6365C18.2331 25.6365 17.9715 24.3165 17.9845 23.5192C17.9845 22.709 18.3402 21.4493 19.3137 21.4493Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_875_3189",
    x1: 25.4198,
    y1: 23.5002,
    x2: 14.0003,
    y2: 23.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOutlook);
export default __webpack_public_path__ + "static/media/logo-outlook.970ed26b92ea6991523500b6ffb78069.svg";
export { ForwardRef as ReactComponent };